import "./HeroSlider.css";
import { Link } from "react-router-dom";

import banner1 from "../../assets/image/01.jpg";
import banner2 from "../../assets/image/02.webp";
import banner3 from "../../assets/image/03.webp";

const HeroSlider = () => {
  return (
    <div
      id="heroCarousel"
      className="carousel slide hero-slider"
      data-bs-ride="carousel"
      data-bs-interval="4000"
      data-bs-pause="false"
    >
      {/* DOTS */}
      <div className="carousel-indicators">
        <button data-bs-target="#heroCarousel" data-bs-slide-to="0" className="active" />
        <button data-bs-target="#heroCarousel" data-bs-slide-to="1" />
        <button data-bs-target="#heroCarousel" data-bs-slide-to="2" />
      </div>

      <div className="carousel-inner">
        {/* SLIDE 1 */}
        <div className="carousel-item active">
          <div className="hero-bg" style={{ backgroundImage: `url(${banner1})` }} />
          <div className="hero-overlay" />

          <div className="container h-100">
            <div className="row h-100 align-items-center">
              <div className="col-lg-6 hero-content">
                <h1 className="hero-title">Global Same Day Shipping</h1>
                <p className="hero-text">
                  For in-stock orders placed before 3:30PM (GMT+8)
                </p>

                <div className="hero-actions">
                  <Link to="/about" className="hero-btn primary">
                    Learn more
                  </Link>

                  <Link to="/video" className="hero-btn">
                    Watch video ▶
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SLIDE 2 */}
        <div className="carousel-item">
          <div className="hero-bg" style={{ backgroundImage: `url(${banner2})` }} />
          <div className="hero-overlay" />

          <div className="container h-100">
            <div className="row h-100 align-items-center">
              <div className="col-lg-6 hero-content">
                <h1 className="hero-title">Enterprise Network Solutions</h1>
                <p className="hero-text">
                  Reliable, scalable & cost-effective networking
                </p>

                <Link to="/solutions" className="hero-btn">
                  Explore
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* SLIDE 3 */}
        <div className="carousel-item">
          <div className="hero-bg" style={{ backgroundImage: `url(${banner3})` }} />
          <div className="hero-overlay" />

          <div className="container h-100">
            <div className="row h-100 align-items-center">
              <div className="col-lg-6 hero-content">
                <h1 className="hero-title">Data Center Infrastructure</h1>
                <p className="hero-text">
                  From optical modules to complete solutions
                </p>

                <Link to="/products" className="hero-btn">
                  View Products
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;
